<template>
    <div style="padding-top: 50px;">
        <div class="columns">
            <div class="column has-text-centered">
                <h1 class="title">Favorites</h1>
            </div>
        </div>
        <div class="columns">
            <div class="column has-text-centered">
                <h3 class="total-title title">Total: {{ totalFavorites }}</h3>
            </div>
        </div>
        <app-loader :loading="getLoaderStatus" :color="optionsLoader.color" :size="optionsLoader.size"></app-loader>
        <div class="columns" v-if="!getLoaderStatus">
            <div class="column">
                <div class="table-container center-column bid-table-container">
                    <table class="theme-table table is-responsive is-fullwidth is-striped bids-table">
                        <thead>
                        <tr>
                            <th>Client</th>
                            <th class="long"><span @click="setOrder('added_date')" class="link">Added Day</span></th>
                            <th class="long"><span @click="setOrder('lot_date')" class="link">Day</span></th>
                            <th>Photos</th>
                            <th><span @click="setOrder('auction_name')" class="link">Auction</span><br>
                                <span @click="setOrder('bid')" class="link">Lot</span></th>
                            <th class="tooltip" data-tooltip="Translation">T</th>
                            <th>Counter-offer</th>
                            <th class="long">Start Price</th>
                            <th class="long">Result</th>
                            <th><span @click="setOrder('company')" class="link">Brand</span></th>
                            <th><span @click="setOrder('model_name')" class="link">Model</span></th>
                            <th><span @click="setOrder('model_type_en')" class="link">Chassis</span></th>
                            <th><span @click="setOrder('mileage_num')" class="link">Km's</span></th>
                            <th><span @click="setOrder('model_year_en')" class="link">Year</span></th>
                            <th><span @click="setOrder('displacement')" class="link">CC.</span></th>
                            <th><span @click="setOrder('transmission')" class="link">Trans.</span></th>
                            <th><span @click="setOrder('scores')" class="link" data-tooltip="Score">Sc.</span></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        <!--<tr class="top-header">
                            <th></th>
                            <th><span class="link">Date</span></th>
                            <th><span class="link">Place</span></th>
                            <th><span class="link">Model</span></th>
                            <th></th>
                            <th><span class="link">Chassis</span></th>
                            <th><span class="link">Mileage</span></th>
                            <th><span class="link">Color</span></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr class="bottom-header">
                            <th>Photo</th>
                            <th>Time</th>
                            <th><span class="link">Lot No</span></th>
                            <th><span class="link">Lot No</span></th>
                            <th><span class="link">Grade</span></th>
                            <th><span class="link">Year</span></th>
                            <th><span class="link">Engine Size</span></th>
                            <th><span class="link">Transmission</span></th>
                            <th><span class="link">Score</span></th>
                            <th><span class="link">Start/Price</span></th>
                            <th><span class="link">Result</span></th>
                            <th></th>
                            <th></th>
                        </tr>-->
                        </thead>
                        <tbody>
                        <favorites-table-row v-for="favorite in favorites" :favorite="favorite"></favorites-table-row>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="columns" v-if="totalFavorites">
            <div class="column has-text-centered">
                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li><a class="pagination-link" v-if="query.page > 2" @click="changePage(firstPage)">{{ firstPage }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="query.page > 2">&hellip;</span></li>
                        <li><a class="pagination-link" v-if="query.page > 1" @click="changePage(query.page - 1)">{{ query.page - 1 }}</a></li>
                        <li><a class="pagination-link is-current" @click="changePage(query.page)">{{ query.page }}</a></li>
                        <li><a class="pagination-link" v-if="query.page < lastPage"  @click="changePage(query.page + 1)">{{ query.page + 1 }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="query.page + 1 < lastPage">&hellip;</span></li>
                        <li><a class="pagination-link" @click="changePage(lastPage)" v-if="query.page + 1 < lastPage">{{ lastPage }}</a></li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="columns" v-if="false">
            <div class="column">
                <div class="has-text-centered">
                    <button class="button is-large"
                            :class="{'is-loading' : isLoading }"
                            @click.prevent="loadMore()"
                            :disabled="isLastPage">
                        <span>Load More</span>
                    </button>
                </div>
            </div>
        </div>
        <gallery :isOpen="isOpen" :items="items" :options="options" @close="closeGallery"></gallery>

    </div>
</template>

<script>
    import apiFavorites from '../../api/apiFavorites'
    import FavoritesTableRow from './FavoritesTableRow'
    import Gallery from './../Auctions/Advance/Result/Gallery'
    import TransferFavoriteModal from "./TransferFavoriteModal";
    import appLoader from 'vue-spinner/src/ClipLoader'

    export default {
        components: {
            TransferFavoriteModal,
            FavoritesTableRow,
            Gallery,
            appLoader
        },
        data() {
            return {
                optionsLoader: this.$store.getters.getOptions,
                favorites: [],
                isLoading: false,
                firstPage: 1,
                lastPage: 1,
                totalFavorites: 0,
                query: {
                    page: 1
                }
            }
        },
        computed: {
            isOpen() {
                return this.$store.getters.getResultGalleryStatus
            },
            items() {
                return this.$store.getters.getResultGalleryItems
            },
            options() {
                return this.$store.getters.getResultGalleryOptions
            },
            isLastPage() {
                return this.query.page >= this.lastPage
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            }
        },
        methods: {
            closeGallery() {
                this.$store.dispatch('setResultGalleryStatus', false)
            },
            loadMore() {
                this.$store.dispatch('setStatusLoading')
                this.query.page = this.query.page + 1
                apiFavorites
                    .favoritesListRequest(this.query)
                    .then((response) => {
                        this.favorites = response.data.data
                        this.lastPage = response.data.last_page
                        this.query.page = response.data.current_page
                        this.totalFavorites = response.data.total
                        this.$store.dispatch('setStatusLoaded')
                    })
                    .catch((error) => {
                        this.$store.dispatch('setStatusLoaded')
                        console.log(error)
                    })
            },
            changePage(page) {
                this.$router.push({path: '/favorites', query: {page: page}})
            },
            setOrder(column){

            }
        },
        mounted() {
            this.$store.dispatch('setStatusLoading')
            if(this.$route.query.page !== undefined){
                this.query.page = this.$route.query.page
            }
            apiFavorites
                .favoritesListRequest(this.query)
                .then((response) => {
                    this.favorites = response.data.data
                    this.lastPage = response.data.last_page
                    this.query.page = response.data.current_page
                    this.totalFavorites = response.data.total
                    this.$store.dispatch('setStatusLoaded')
                })
                .catch((error) => {
                    console.log(error)
                    this.$store.dispatch('setStatusLoaded')
                })
        },
        watch: {
            '$route'(to, from) {
                this.$store.dispatch('setStatusLoading')
                this.query.page = to.query.page;
                apiFavorites
                    .favoritesListRequest(this.query)
                    .then((response) => {
                        this.favorites = response.data.data
                        this.lastPage = response.data.last_page
                        this.query.page = response.data.current_page
                        this.totalFavorites = response.data.total
                        this.$store.dispatch('setStatusLoaded')
                    })
                    .catch((error) => {
                        this.$store.dispatch('setStatusLoaded')
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>
    th {
        font-size: small;
    }

    .top-header th {
        border-bottom: none;
        background-color: whitesmoke;
    }

    .bottom-header th {
        border-top: none;
        background-color: whitesmoke;
    }
</style>


// WEBPACK FOOTER //
// src/components/Favorites/FavoritesTable.vue